import { render, staticRenderFns } from "./ArtworkImage.vue?vue&type=template&id=2acbbe9a&scoped=true&"
import script from "./ArtworkImage.vue?vue&type=script&lang=js&"
export * from "./ArtworkImage.vue?vue&type=script&lang=js&"
import style0 from "./ArtworkImage.vue?vue&type=style&index=0&id=2acbbe9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acbbe9a",
  null
  
)

export default component.exports